module.exports = __webpack_public_path__ + "img/Weapon_48.f90e635f.png";